export {StatusOverlayComponent as StatusOverlay} from '../StatusOverlayComponent';



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/components/StatusOverlay/index.js